module.exports = __webpack_public_path__ + "img/AdobeStock_270290600.2c3de857.jpeg";